const defaultImg =
  "https://padehrs3-staging.s3.us-east-2.amazonaws.com/images/275a55ef-52e5-4b0f-b941-12fe0f215876.png"

type Props = React.ImgHTMLAttributes<HTMLImageElement>

const Avatar: React.FC<Props> = ({ src, alt, ...rest }) => {
  return (
    <img
      src={src ? src : defaultImg}
      alt={alt ? alt : ""}
      {...rest}
    />
  )
}

export default Avatar
